import { memo } from 'react';
import { Tooltip } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { cx } from '@emotion/css';
import { formatNumber } from 'utils/numberFormat';

interface ProgressBarProps {
  progress: number;
  className?: string;
}
const ProgressBar = memo((props: ProgressBarProps) => {
  const { progress, className } = props;
  const r = 3;
  const p = Math.PI * 2 * r;
  const x = ((progress / 100) * p).toFixed(1);
  const { t } = useTranslate();

  return (
    <Tooltip title={`${t('完成度')} ${formatNumber(progress / 100, '0.0%')}`}>
      {progress === 100 ? (
        <div
          className={className}
          style={{
            width: r * 4 + 4,
            height: r * 4 + 4,
            borderRadius: '50%',
            backgroundColor: '#3360ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CheckOutlined style={{ color: '#fff', fontSize: 12 }} />
        </div>
      ) : (
        <div
          className={cx(
            'border border-solid border-[2px] border-[#3360ff] inline-block flex items-center justify-center',
            className,
          )}
          style={{
            width: r * 4,
            height: r * 4,
            borderRadius: '50%',
            boxSizing: 'content-box',
          }}
        >
          <svg width={r * 4} height={r * 4}>
            <circle
              cx={r * 2}
              cy={r * 2}
              r={r}
              fillOpacity="0"
              stroke="#3360ff"
              strokeWidth={r * 2}
              strokeDasharray={`${x} ${(p - Number(x)).toFixed(1)}`}
              strokeDashoffset={(p / 4).toFixed(1)}
            />
          </svg>
        </div>
      )}
    </Tooltip>
  );
});

ProgressBar.displayName = 'SingleClassNewProgressBar';

export default ProgressBar;
